var forOwn = require('./forOwn');

    /**
     * Get object keys
     */
     var keys = Object.keys || function (obj) {
            var keys = [];
            forOwn(obj, function(val, key){
                keys.push(key);
            });
            return keys;
        };

    module.exports = keys;





/*****************
 ** WEBPACK FOOTER
 ** ./~/mout/object/keys.js
 ** module id = 23
 ** module chunks = 0
 **/